

import React from 'react';
import { TableCell, TableRow } from '@mui/material';
import { Image, Space } from "antd";
import customStyles from "../../../../../assets/styles/customStyles";
import { frequencyHead } from "../../../../../config/constant";
import { NavLink } from "react-router-dom";
import clsx from "clsx";
import EditIcon from "../../../../../assets/images/icon_actions/Edit.svg";
import DeleteIcon from "../../../../../assets/images/icon_actions/Delete Icon.svg";
import CustomInfiniteScroll from "../../../../Shared/components/CustomInfiniteScroll";
import ViewIcon from "../../../../../assets/images/icon_actions/View.svg";
import { checkCRUDPermission, getColumnWidth, capitalizeFirstLetter } from "../../../../../helpers/utilities";

export const ListTable = (props) => {
    const { onRequestSort, sortOrder, sortBy,
        details, loadMore, onView,
        loadMoreContent, loadMoreTask,
        onEdit, onDelete, roleManagement } = props;

    const classes = customStyles();
    return (
        <CustomInfiniteScroll
            loadMore={loadMore}
            loadMoreContent={loadMoreContent}
            loadMoreTask={loadMoreTask}
            heads={frequencyHead}
            onRequestSort={(sortBy, sortOrder) => onRequestSort(sortBy, sortOrder)}
            sortOrder={sortOrder}
            sortBy={sortBy}
            width={true}
            component={
                <>
                    {
                        !loadMore || details === '' ? (
                            <TableRow sx={{ '&:last-child td, &:last-child th': { border: 0 } }}>
                                <TableCell className={classes.textAlignCenter} colSpan={8}><div className={classes.loadMoreCircle}></div></TableCell>
                            </TableRow>
                        ) : (
                            <React.Fragment>
                                {
                                    details && Array.isArray(details) && details.length > 0 ? details.map((data, i) => (
                                        <TableRow
                                            key={i} sx={{ '&:last-child td, &:last-child th': { border: 0 } }}>
                                            <TableCell style={{ width: getColumnWidth(frequencyHead, 0) }}>
                                                {
                                                    roleManagement !== '' && checkCRUDPermission('Brands', 'view', 'Younote Admin') ?
                                                        <NavLink style={{ width: getColumnWidth(frequencyHead, 0) }} to={"#"} onClick={() => onView(data)} className={clsx(classes.color, classes.wordBreak, classes.positionRelative, classes.PaddingRight50, classes.disBlock, classes.bold)}>{data?.name}</NavLink>
                                                        : <span style={{ width: getColumnWidth(frequencyHead, 0) }}>{data.name || '---'}</span>
                                                }
                                            </TableCell>
                                            <TableCell style={{ width: getColumnWidth(frequencyHead, 1) }}><span style={{ width: getColumnWidth(frequencyHead, 1) }}>{data?.description || '---'}</span></TableCell>
                                            <TableCell style={{ width: getColumnWidth(frequencyHead, 2) }}><span style={{ width: getColumnWidth(frequencyHead, 2) }}>{capitalizeFirstLetter(data?.repeatType || '---')}</span></TableCell>
                                            <TableCell style={{ width: getColumnWidth(frequencyHead, 3) }}><span style={{ width: getColumnWidth(frequencyHead, 3) }}>{data?.occurenceCount || '---'}</span></TableCell>

                                            <TableCell>
                                                <Space direction="horizontal" align="center" size={[0, 0]} className={classes.iconPadding}>
                                                    {
                                                        roleManagement !== '' && checkCRUDPermission('Schedule Frequency', 'view', 'Younote Admin') &&
                                                        <NavLink to={"#"} onClick={() => onView(data)}>
                                                            <Image src={ViewIcon} preview={false} />
                                                        </NavLink>
                                                    }
                                                    {
                                                        roleManagement !== '' && checkCRUDPermission('Schedule Frequency', 'edit', 'Younote Admin') &&
                                                        <NavLink to={"#"} onClick={() => onEdit(data)}>
                                                            <Image src={EditIcon} preview={false} />
                                                        </NavLink>
                                                    }
                                                    {
                                                        roleManagement !== '' && checkCRUDPermission('Schedule Frequency', 'deletable', 'Younote Admin') &&
                                                        <NavLink to={"#"} onClick={() => onDelete(data)} >
                                                            <Image src={DeleteIcon} preview={false} />
                                                        </NavLink>
                                                    }
                                                </Space>
                                            </TableCell>
                                        </TableRow>
                                    )) : (
                                        <TableRow sx={{ '&:last-child td, &:last-child th': { border: 0 } }}>
                                            <TableCell className={classes.textAlignCenter} colSpan={8}> <p className={clsx(classes.noResultsText, classes.textAlignCenter)}>{'No results found'}</p></TableCell>
                                        </TableRow>
                                    )
                                }
                            </React.Fragment>
                        )
                    }
                </>
            }
        />
    )
}